import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ROLE_MAP = {
  buyer_owner_tenant: "common",
  agent: "agent",
  builder: "builder"
};

export default function Register() {
  const navigate = useNavigate();
  const location = useLocation();
  const { signup } = useAuth();

  const [form, setForm] = useState({
    userType: "buyer_owner_tenant",
    full_name: "",
    email: "",
    password: "",
    mobile: "",
    acceptTerms: false
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onChange = (event) => {
    const { name, value, type, checked } = event.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (!form.full_name.trim() || !form.email.trim() || !form.password.trim() || !form.mobile.trim()) {
      setError("Name, email, password and mobile number are required.");
      return;
    }

    if (!form.acceptTerms) {
      setError("Please accept Terms and Privacy Policy.");
      return;
    }

    try {
      setLoading(true);
      const user = await signup({
        full_name: form.full_name,
        email: form.email,
        password: form.password,
        mobile: form.mobile,
        role: ROLE_MAP[form.userType],
        account_type: form.userType
      });
      const dashboardRoute = user.role === "admin" ? "/admin/queue" : "/account";

      if (location.state?.openPostProperty) {
        navigate(dashboardRoute, {
          state: {
            openPostProperty: true,
            selectedType: location.state?.selectedType,
            listingType: location.state?.listingType,
            postPropertySource: "dashboard",
            message: "Account created. Continue with your posting setup."
          }
        });
        return;
      }

      navigate(dashboardRoute);
    } catch (requestError) {
      const message = requestError?.response?.data?.detail || "Registration failed.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-page">
      <section className="signup-right-panel">
        <div className="signup-card-modern">
          <h3>Sign Up</h3>

          {location.state?.prompt ? <div className="feedback-banner info-banner">{location.state.prompt}</div> : null}
          {error ? <div className="feedback-banner error-banner">{error}</div> : null}

          <form onSubmit={onSubmit}>
            <label className="signup-label">I am</label>
            <div className="signup-role-row">
              <label
                className={`signup-role-pill ${form.userType === "buyer_owner_tenant" ? "active" : ""}`}
              >
                <input
                  type="radio"
                  name="userType"
                  value="buyer_owner_tenant"
                  checked={form.userType === "buyer_owner_tenant"}
                  onChange={onChange}
                />
                Buyer/Owner/Tenant
              </label>
              <label className={`signup-role-pill ${form.userType === "agent" ? "active" : ""}`}>
                <input
                  type="radio"
                  name="userType"
                  value="agent"
                  checked={form.userType === "agent"}
                  onChange={onChange}
                />
                Agent
              </label>
              <label className={`signup-role-pill ${form.userType === "builder" ? "active" : ""}`}>
                <input
                  type="radio"
                  name="userType"
                  value="builder"
                  checked={form.userType === "builder"}
                  onChange={onChange}
                />
                Builder
              </label>
            </div>

            <input
              className="auth-input"
              type="text"
              name="full_name"
              placeholder="Name"
              value={form.full_name}
              onChange={onChange}
            />

            <input
              className="auth-input"
              type="email"
              name="email"
              placeholder="Email"
              value={form.email}
              onChange={onChange}
            />

            <input
              className="auth-input"
              type="password"
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={onChange}
            />

            <div className="signup-mobile-row">
              <select className="auth-input" value="+91" disabled>
                <option>IND +91</option>
              </select>
              <input
                className="auth-input"
                type="text"
                name="mobile"
                placeholder="Mobile Number"
                value={form.mobile}
                onChange={onChange}
              />
            </div>

            <label className="signup-terms">
              <input
                type="checkbox"
                name="acceptTerms"
                checked={form.acceptTerms}
                onChange={onChange}
              />
              <span>
                I agree to PropertySphere <a href="#/">T&amp;C</a>, <a href="#/">Privacy Policy</a> and <a href="#/">Cookie Policy</a>
              </span>
            </label>

            <button className="auth-btn" type="submit" disabled={loading}>
              {loading ? "Creating account..." : "Sign Up"}
            </button>
          </form>

          <div className="auth-footer">
            Already registered? <Link to="/login" state={location.state}>Login Now</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
